import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { memo } from "react";

const CircularCentered = memo(() => {
    return (
        <Box display="flex" alignItems="center" justifyContent="center" height="100%">
            <CircularProgress />
        </Box>
    );
});

export default CircularCentered;
